import { mergeAttributes } from '@tiptap/core';
import Paragraph from '@tiptap/extension-paragraph';
import DOMPurify from 'dompurify';
import { DOMParser as proseMirrorParser } from 'prosemirror-model';

function transformHTML(html) {
    try {
        // Use DOMPurify to sanitize and remove unwanted styles/scripts
        const cleanHTML = DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['ul', 'ol', 'li', 'strong', 'em', 'u', 'br', 'p'], // No tags allowed
            ALLOWED_ATTR: []  // No attributes allowed
        });

        // Further processing to extract text content
        const parser = new DOMParser();
        const doc = parser.parseFromString(cleanHTML, 'text/html');
        // Extract text content from the document
        const textContent = doc.body.innerHTML || '';

        return `<p>${textContent}</p>`;
    } catch (error) {
        console.error('Error transforming HTML:', error);
        return ''; // Return an empty string or handle the error as needed
    }
}

const createNodeFromHTML = (html, view) => {
    try {
        const cleanHTML = transformHTML(html);
        const parser = new DOMParser();
        const doc = parser.parseFromString(cleanHTML, 'text/html');

        const { schema } = view.state;
        const parsedSlice = proseMirrorParser.fromSchema(schema).parse(doc.body);
        if (!parsedSlice) {
            throw new Error('Parsed slice is invalid');
        }

        // console.log(html, parsedSlice, schema)
        // Determine the position to insert the content

        // Create a transaction to insert the parsed slice at the specified position
        const position = view.state.selection.from; // or any specific position
        const transaction = view.state.tr.insert(position, parsedSlice.content);
        view.dispatch(transaction);
        return true;
    }
    catch (e) {
        console.error("Error creating node from HTML:", e.message, e.stack);
        return false;
    }

};
export const CustomParagraph = Paragraph.extend({
    renderHTML({ HTMLAttributes }) {
        return ['p', mergeAttributes(HTMLAttributes, { class: 'my-custom-tiptap-class' }), 0];
    },
});



export const handlePaste = (view, event) => {
    const { clipboardData } = event;
    const html = clipboardData.getData('text/html');
    if (html) {
        const isInternal = html.includes('my-custom-tiptap-class');
        if (isInternal) return false // Do not transform internal content
        return createNodeFromHTML(html, view);
    }

    // Default paste handling
    return false;
}

